import { defineStore } from 'pinia';
import { getAttendanceListApi, exportAttendanceRecordApi, getAttendanceDetailApi } from '@blade-sxp/record-center/api/attendanceRecord';
export const useAttendanceRecordStore = defineStore('attendanceRecordStore', () => {
    const getAttendanceList = async (data) => {
        try {
            const res = await getAttendanceListApi(data);
            return res;
        }
        catch (e) {
            console.log(e);
            throw e;
        }
    };
    const exportAttendanceRecord = async (data) => {
        try {
            const res = await exportAttendanceRecordApi(data);
            return res;
        }
        catch (e) {
            console.log(e);
            throw e;
        }
    };
    const getAttendanceDetail = async (data) => {
        try {
            const res = await getAttendanceDetailApi(data);
            return res;
        }
        catch (e) {
            console.log(e);
            throw e;
        }
    };
    return { getAttendanceList, exportAttendanceRecord, getAttendanceDetail };
});
